// app/javascript/controllers/slim_select_controller.js
import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"
import { slimSelectSettings } from "../helpers/slim_select_helpers"

export default class extends Controller {
  connect() {
    this.slimSelect = new SlimSelect({
      select: this.element,
      settings: slimSelectSettings({
        allowDeselect: true,
        showSearch: true,
        searchPlaceholder: "Gerät suchen oder hinzufügen",
        placeholderText: this.element.dataset.placeholder
          ? this.element.dataset.placeholder
          : "Auswählen",
        addableText: '"{value}" hinzufügen (Enter drücken)',
      }),
      events: {
        addable: (value) => {
          return value
        },
      },
    })
  }

  disconnect() {
    this.slimSelect.destroy()
  }

  submit() {
    this.element.closest("form").requestSubmit()
  }
}
